import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnumRoles } from '../models/EnumTypes';
import {environment} from "../../environments/environment";
import { KeycloakService } from './keycloak.service';
import { v4 as uuidv4 } from 'uuid';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class EndpointsService {

  public static readonly AUTH_TOKEN: string = "AuthToken";
  private static readonly USER_ROLES_TOKEN: string = "UserRolesToken";
  public static readonly SESSION_ID: string = "sessionID";

  private static readonly DEBUG_TOKEN: string = "eyJhbGciOiJIUzUxMiJ9.eyJST0xFUyI6WyJST0xFX0FETUlOIiwiUk9MRV9WSUVXRVIiLCJST0xFX1dSSVRFUiJdLCJzdWIiOiJlY3RsIiwiaWF0IjoxNzgzMzQ2OTY1LCJleHAiOjE3ODMzNjQ5NjV9.C7XwI0FYNZW1UL7HaiQN3Tn9gEH7Rm2PPGbCCRhDG-NWRovuEZCNUV0N6GGdO1-BXNBZqqdjZ5xjnSFpro3nvg"
  progressCalculationUrl = `${environment.calculation}/progress`;
  coverageUrl = `${environment.calculation}/calculateCoverage`;
  cumulativeUrl = `${environment.calculation}/calculateCumulativeCoverage`;
  overlapUrl = `${environment.calculation}/calculateOverlap`;
  performanceUrl = `${environment.calculation}/calculatePerformance`;
  performanceAnalysisUrl = `${environment.calculation}/calculatePerformanceAnalysis`;
  verticalProfileUrl = `${environment.calculation}/calculateVerticalProfile`;
  routePerformanceReportUrl = `${environment.calculation}/calculateRoutePerformance`;
  calculateCoverageForProcessingToolSecondStage = `${environment.calculation}/calculateCoverageForProcessingToolSecondStage`;
  generatePerformanceReportUrl = `${environment.calculation}/generatePerformanceReport`;
  horizonRingsUrl = `${environment.calculation}/calculateHorizonRings`;
  sitingToolUrl = `${environment.calculation}/calculateSitingTool`;
  navaidFromMapUrl = `${environment.calculation}/calculateNavaidFromMap`;
  coverageQuantitativeAssessmentUrl = `${environment.calculation}/calculateCQA`;
  crossSectionUrl = `${environment.calculation}/calculateCrossSection`;
  altitudeCutUrl = `${environment.calculation}/calculateAltitudeCut`;
  getShapeFileFromGeoJson = `${environment.calculation}/geojsontoshapefile`;
  getGeoJsonFromShapeFile = `${environment.calculation}/shapefiletogeojson`;
  getCalcInfo = `${environment.calculation}/calculationInfo`;
  getCalculation = `${environment.calculation}/calculation`;
  isUserPerformingCalculations = `${environment.calculation}/isUserPerformingCalculations`;

  cancelCalculation = `${environment.calculation}/cancelCalculation`;
  previousCalculations = `${environment.calculation}/calculations`;
  previousPartialCalculations = `${environment.calculation}/partialcalculations`;
  saveCalculations = `${environment.calculation}/saveCalculations`;
  deleteCalculation = `${environment.calculation}/delete`;
  deleteBulkCalculation = `${environment.calculation}/bulkDelete`;
  deleteCalculationsByProject = `${environment.calculation}/deleteByProject`;
  docAndSectorizationUrl =`${environment.calculation}/calculateDocAndSectorizationDisplay`;
  terrainGrid = `${environment.calculation}/terrainGrid`

  getAllErrorLogs = `${environment.calculation}/getAllErrorLogs`
  downloadErrorLogs = `${environment.calculation}/downloadErrorLogs`
  deleteAllErrorLogs = `${environment.calculation}/deleteAllErrorLogs`

  apiUrlTerrains = `${environment.calculation}/terrains`
  endpointUpdateTerrainWithNewFile = `${environment.calculation}/terrains/updateWithFile`
  endpointGetChunkSize = `${environment.calculation}/terrains/getChunkSize`
  endpointFetchTerrainById = `${environment.calculation}/terrains/fetchById`
  endpointGetTerrainTypes = `${environment.calculation}/terrains/terrainTypes`
  endpointUploadTerrainsFromProject = `${environment.calculation}/terrains/importFromProject`
  endpointGetTerrainResolution = `${environment.calculation}/terrains/terrainResolution`
  endpointGetTerrainUploadInProgress = `${environment.calculation}/terrains/uploadInProgress`
  endpointGetTerrainValidationInProgress = `${environment.calculation}/terrains/validationInProgress`
  endpointDeleteTerrainUploadInProgress = `${environment.calculation}/terrains/deleteUploadProgress`
  endpointValidateTerrain = `${environment.calculation}/terrains/validateTerrain`
  terrainHeightUrl = `${environment.calculation}/terrains/calculateTerrainHeight`;
  terrainHeightBulkUrl = `${environment.calculation}/terrains/calculateTerrainHeightBulk`;
  apiUrlValidateCoordinates = `${environment.calculation}/terrains/validateCoordinates`;

  deleteCalculationsCache = `${environment.calculation}/deleteCache`

  apiPendingCalculation = `${environment.calculation}/pendingCalculation`
  getAllPendingCalculations = `${environment.calculation}/pendingCalculations`

  antennaModelsAPI = `${environment.calculation}/antennaModels`
  downloadAntennaFile = `${environment.calculation}/antennaModels/downloadFile`

  userSpaceAPI = `${environment.calculation}/userspace`;
  deleteCalculationsDatabase = `${this.userSpaceAPI}/deleteCalculationsDatabase`
  checkCalculationsDatabase = `${this.userSpaceAPI}/calculationDatabaseExists`

  removeGroundStations = `${environment.calculation}/removeGroundStations`;


  apiUrl = `${environment.navaids}/navaids`;
  endpointNavaidsCount = `${environment.navaids}/navaids/count`;
  endpointPartialNavaids = `${environment.navaids}/partialnavaids`
  endpointCriticalNavaids = `${environment.navaids}/criticalnavaids`;
  endpointValidate = `${environment.navaids}/navaids/validate`;
  endpointItuIcao = `${environment.navaids}/navaids/itu`;
  endpointParseImportFileNavaids = `${environment.navaids}/navaids/parseImportFile`;
  endpointImportNavaids = `${environment.navaids}/navaids/import`;
  endpointDownload  = `${environment.navaids}/navaids/download`;
  endpointUserSettingsCreate= `${environment.navaids}/userSettings/create`;
  endpointUserSettingsGet = `${environment.navaids}/userSettings/get`;
  endpointsUserSettingsUpdate = `${environment.navaids}/userSettings/update`;
  endpointParseSAAMTrafficFile = `${environment.navaids}/parseSAAMTrafficFile`;
  endpointGetAllSAAMTraffic = `${environment.navaids}/getAllSAAMTraffic`;
  endpointDeleteSAAMTraffic = `${environment.navaids}/deleteSAAM`;
  endpointBulkDeleteSAAMTraffic = `${environment.navaids}/bulkDeleteSAAMLayer`;
  endpointBulkDelete = `${environment.navaids}/navaids/bulkDelete`;

  endpointExportNavaidsToSafire = `${environment.navaids}/navaids/exportToSafireFile`

  apiUrlCoordinatePoints = `${environment.navaids}/coordinatepoints`;
  endpointCoordinatePointsCount = `${environment.navaids}/coordinatepoints/count`;
  endpointPartialCoordinatePoints = `${environment.navaids}/partialcoordinatepoints`;
  endpointParseImportFileCoordinatePoints = `${environment.navaids}/coordinatepoints/parseImportFile`;
  endpointDownloadCoordinatePoints = `${environment.navaids}/coordinatepoints/download`;
  endpointUploadCoordinatePoints = `${environment.navaids}/coordinatepoints/upload`;
  endpointBulkDeleteCoordinatePoints = `${environment.navaids}/coordinatepoints/bulkDelete`;
  endpointGetCoordinatePointsByCoordinates = `${environment.navaids}/coordinatepointsByCoordinates`;
  endpointGetCoordindatesByIds = `${environment.navaids}/getCoordinatepointsByIds`
  endpointGetDuplicateCoordindatePointsByIds = `${environment.navaids}/duplicateCoordinatePointsByIds`

  apiURLTabsCreate = `${environment.navaids}/tabs/create`;
  apiURLTabsUpdate = `${environment.navaids}/tabs/update`;
  apiURLTabsGet = `${environment.navaids}/tabs/get`;
  apiUrlProcedures = `${environment.navaids}/procedures`;
  endpointPartialProcedures = `${environment.navaids}/partialprocedures`;
  apiUrlProceduresBulkUpdate = `${environment.navaids}/procedures/bulkUpdate`;
  apiUrlProceduresBulkStatusUpdate = `${environment.navaids}/procedures/bulkStatusUpdate`;
  endpointParseImportFileProcedures = `${environment.navaids}/procedures/parseImportFile`;
  endpointUploadProcedures = `${environment.navaids}/procedures/upload`;
  endpointDownloadProcedures = `${environment.navaids}/procedures/download`;
  endpointBulkDeleteProcedure = `${environment.navaids}/procedures/bulkDelete`;

  endpointAddFlightInspection = `${environment.navaids}/addFlightInspection`
  endpointGetAllFlightInspection = `${environment.navaids}/getAllFlightInspection`
  endpointDeleteFlightInspection = `${environment.navaids}/deleteFlightInspection`
  endpointGetFlightInspectionConfig = `${environment.navaids}/flightInspection/getConfig`
  endpointImportProcessingTool = `${environment.navaids}/flightInspection/importProcessingTool`
  endpointImportProcessingToolFirstStage = `${environment.navaids}/flightInspection/importProcessingToolFirstStage`
  endpointImportProcessingToolThirdStage = `${environment.navaids}/flightInspection/importProcessingToolThirdStage`
  endpointGetAllProcessingTool = `${environment.navaids}/flightInspection/getAllProcessingTool`
  endpointGetProcessingTool = `${environment.navaids}/flightInspection/getProcessingTool`
  endpointDeleteProcessingTool = `${environment.navaids}/flightInspection/deleteProcessingTool`
  endpointBulkDeleteFlightInspectionTool = `${environment.navaids}/flightInspection/bulkDelete`
  endpointBulkDeleteProcessingTool = `${environment.navaids}/flightInspection/processingToolBulkDelete`

  endpointParseImportFileRouteSegments = `${environment.navaids}/routesegments/parseImportFile`;
  routeSegmentsUrl = `${environment.navaids}/routesegments`;

  apiUrlAirSpaceBoundary = `${environment.navaids}/airspaceboundary`;
  endpointPartialAirSpaceBoundaries = `${environment.navaids}/airspaceboundary/partialairspaceboundaries`;
  apiUrlAirSpaceBoundaryBulkUpdate = `${environment.navaids}/airspaceboundary/bulkUpdate`;
  endpointUploadAirSpaceBoundary = `${environment.navaids}/airspaceboundary/upload`;
  endpointDownloadAirSpaceBoundary = `${environment.navaids}/airspaceboundary/download`;
  endpointBulkDeleteAirSpaceBoundary = `${environment.navaids}/airspaceboundary/bulkDelete`;


  apiUrlTrajectory = `${environment.navaids}/trajectory`;
  endpointPartialTrajectories = `${environment.navaids}/trajectory/partialtrajectories`;
  apiUrlTrajectoryBulkStatusUpdate = `${environment.navaids}/trajectory/bulkStatusUpdate`;
  endpointUploadTrajectory = `${environment.navaids}/trajectory/upload`;
  endpointUploadTrajectoryKMZ = `${environment.navaids}/trajectory/uploadKMZ`;
  endpointBulkDeleteTrajectory = `${environment.navaids}/trajectory/bulkDelete`;
  endpointDownloadTrajectoryXML = `${environment.navaids}/trajectory/download`;

  endpointOffset = `${environment.calculation}`;

  apiUrlCalculateCurvePoints = `${environment.navaids}/procedures/calculateCurvePoints`;


  apiUrlProjects =`${environment.navaids}/projects`;
  apiUrlActivateProject =`${environment.navaids}/projects/activate`;
  endpointUploadProject =`${environment.navaids}/projects/upload`;
  endpointDeleteEntitiesCache =`${environment.navaids}/projects/deleteCache`;

  apiUrlConfiguration =`${environment.navaids}/configuration`;
  endpointDownloadConfiguration=`${environment.navaids}/configuration/download`;

  apiUrlAnnotations =`${environment.navaids}/annotation`;
  apiUrlAreas =`${environment.navaids}/area`;
  icaoccUrl =`${environment.navaids}/icaocc`;
  icaoccGetByIsoCode2Bulk =`${environment.navaids}/icaocc/bulkFetch`;

  allNavaidsCSVUrl = `${environment.navaids}/navaids/csv/all`;
  selectedNavaidsCSVUrl = `${environment.navaids}/navaids/csv/selected`;
  duplicatedNavaidsCSVUrl = `${environment.navaids}/navaids/csv`;
  endpointDownloadCSVNavaids = `${environment.navaids}/navaids/downloadCSVNavaids`;
  endPointDownloadCSVCoordPoints = `${environment.navaids}/downloadCSVCoordPoints`;
  sectorizationDisplayUrl =`${environment.sectorization_display}/sectorization`;

  contextualHelpGetAll= `${environment.navaids}/contextualHelp/getAll`
  contextualHelpGet= `${environment.navaids}/contextualHelp/get`
  contextualHelpUpdate= `${environment.navaids}/contextualHelp/update`

  areasXMLDownload=`${environment.navaids}/area/download`
  annotationsXMLDownload= `${environment.navaids}/annotation/download`
  selfTrainingToolDemeterAPI = `${environment.navaids}/trainingTool`
  endpointSelfTrainingExercisesBulkDelete = `${environment.navaids}/trainingTool/bulkDelete`
  endpointSaveSelfTrainingExercises = `${environment.navaids}/trainingTool/saveExercises`
  endpointgetXwikiLoginInfo = `${environment.navaids}/trainingTool/xwikiLoginInfo`

  fetchSessionId = `${environment.navaids}/getSessionId`

  //#region GRIT
  gritDevice = `${environment.grit}/device`
  gritInterferenceTestDevice = `${environment.grit}/interference-test-device`

  gritReceiver = `${environment.grit}/receiver`
  gritInterferenceTest = `${environment.grit}/interference-test`
  gritRadar = `${environment.grit}/radar`
  gritProject = `${environment.grit}/project`
  gritUserProfile = `${environment.grit}/user-profile`

  gritCalculateImpactAssessment = `${environment.calculation}/calculateImpactAssessment`;

  gritSectorization = `${environment.sectorization_display}/sectorization-grit`;
  //endregion

  getUserManagement = `${environment.static_content}/get-approval-request-tables`;
  getUserProfile = `${environment.static_content}/get-single-approval-request-table`;
  applyAction = `${environment.static_content}/user-management-action`;
  approveNormalUsers = `${environment.static_content}/b2c/approve-normal-users`;
  approveAdminUsers = `${environment.static_content}/b2c/approve-admin-users`;
  rejectUsers = `${environment.static_content}/b2c/reject-users`;
  runSchemaMigration = `${environment.static_content}/run-schema-migration`;
  insertUserOnSchema = `${environment.static_content}/insert-user`;

  gdprConsent = `${environment.static_content}/user/gdpr-consent`;
  exportLicenseManagementHistory = `${environment.static_content}/user-management-history/export`;
  supportTickets = `${environment.static_content}/support-tickets`;

  createSession = `${environment.static_content}/create-session`;

  getUserRolesTokenEndpoint = `${environment.static_content}/get-user-roles-token`;

  private userRolesToken: string;
  private userRolesTokenPromise: Promise<string>;

  httpOptions: {
    headers: HttpHeaders;
    body: any;
  }

  httpOptionsTest: {
    headers: HttpHeaders;
    responseType: string;
  }

  httpOptionsAsRecordStrings: Record<string, string>; // used in progress calculations

  jsonHttpOptions: {
    headers: HttpHeaders;
  }

  fileHttpOptions: {
    headers: HttpHeaders;
    responseType: "json";
  }

  constructor(
    private readonly cookieService: CookieService,
    private readonly http: HttpClient,
    private readonly authService: MsalService,
    private readonly keycloakService: KeycloakService
  ) {}

  getSessionID(): string {
    if (sessionStorage.getItem(EndpointsService.SESSION_ID) != null) {
      return sessionStorage.getItem(EndpointsService.SESSION_ID);
    }
    return "localhostSession"; // if browser is in localhost, this will work. If not, backend server will consider the session invalid.
  }

  isLocalHost(): boolean {
    return environment.navaids.startsWith("http://localhost");
  }


  initHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getAuthorizationToken(), 'sessionID': this.getSessionID() }),
      body: null
    }

    this.httpOptionsTest = {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getAuthorizationToken(), 'sessionID': this.getSessionID() }),
      responseType: 'text'
    };

    this.httpOptionsAsRecordStrings = { // used in progress calculations
      "Authorization": "Bearer " + this.getAuthorizationToken(),
      "Content-Type": "text/event-stream",
      "Cache-Control": "no-cache",
      "X-Accel-Buffering": "no",
      'sessionID': this.getSessionID()
    };

    this.jsonHttpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.getAuthorizationToken(),
        'Content-Type': 'application/json',
        'sessionID': this.getSessionID()
      }),
    };
    this.fileHttpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.getAuthorizationToken(),
        'Content-Type': 'application/json',
        'sessionID': this.getSessionID()
      }),
      responseType: 'blob' as 'json'
    }
  }

  getAuthorizationToken() {
    let authToken: string;
    if (environment.useB2cAuthentication) {
      authToken = sessionStorage.getItem(EndpointsService.AUTH_TOKEN);
    } else if (environment.useKeycloakAuthentication) {
      authToken = this.keycloakService.getToken();
    } else {
      authToken = this.cookieService.get(EndpointsService.AUTH_TOKEN);
    }
    if (!authToken || authToken == "undefined" || authToken == "null") {
      //if nothing found returns debug token
      return this.isLocalHost()? EndpointsService.DEBUG_TOKEN: null;
    }
    return authToken;
  }

  getUserRolesToken() {
    if (!environment.useB2cAuthentication && !environment.useKeycloakAuthentication) {
      return this.getAuthorizationToken();
    }

    const userRolesToken = this.userRolesToken || this.cookieService.get(EndpointsService.USER_ROLES_TOKEN); // Get userRolesToken from memory/cookies
    if(!environment.useB2cAuthentication && !environment.useKeycloakAuthentication) {
      if (!userRolesToken || userRolesToken == "undefined" || userRolesToken == "null" ) {
        //if nothing found returns debug token
        return this.isLocalHost() ? EndpointsService.DEBUG_TOKEN : null;
      }
    }
    return userRolesToken;
  }


  async setUserRolesToken(): Promise<string> {
    let userRolesToken: string = this.getUserRolesToken() // Get userRolesToken from cookies

    if ((EndpointsService.isValidJwt(userRolesToken) && !AppComponent.isTokenExpired(userRolesToken)) || this.isLocalHost() && (!environment.useB2cAuthentication && !environment.useKeycloakAuthentication)) {
      return userRolesToken;
    }

    if (this.userRolesTokenPromise) {
      return this.userRolesTokenPromise;
    }

    const token = this.getAuthorizationToken();

    this.userRolesTokenPromise = lastValueFrom(this.http.get<string>(this.getUserRolesTokenEndpoint, {
        headers: new HttpHeaders({ 'Authorization': 'Bearer ' + token, 'sessionID': this.getSessionID() }),
        responseType: 'text' as 'json',
      }))
      .then((fetchedUserRolesToken) => {
        this.userRolesToken = fetchedUserRolesToken;

        this.cookieService.set(EndpointsService.USER_ROLES_TOKEN, fetchedUserRolesToken, {
          path: '/',
          secure: !this.isLocalHost(),
          sameSite: 'Strict'
        });

        return fetchedUserRolesToken;
      })
      .finally(() => {
        this.userRolesTokenPromise = null;
      });

    return this.userRolesTokenPromise;
  }

  public static isValidJwt(token: string): boolean {
    if (environment.useKeycloakAuthentication) {
      // For Keycloak, we assume the token is valid if it's present, as Keycloak handles token validation and refreshing.
      // TODO - Does not have in account the Claims from Keycloak, as in B2C
      return !!token;
    }

    if (!token) return false;
    const parts = token.split('.');
    return parts.length === 3; // A valid JWT has three parts
  }


  async initializeEndpointsService(authToken: string, newLogin: boolean) {
    if (!authToken) {
      return;
    }

    this.setAuthorizationToken(authToken, false);

    try {
      await this.createSessionId(authToken);
    } catch (e) {
      console.error("error creating session ID.", e);
    }
    // GRIT CHANGE
    if (newLogin && !environment.gritMode) {
      await this.sendRunMigrationsRequest();
      await this.sendInsertUserOnSchemaRequest();
    }

    try {
      this.userRolesToken = null;
      this.cookieService.delete(EndpointsService.USER_ROLES_TOKEN, '/');
      await this.setUserRolesToken();
    } catch (e) {
      console.error("error setting user roles token", e);
    }

    this.initHttpOptions(); // this triggers constructor requests




    if (!newLogin) {
      return;
    }
  }

  async sendRunMigrationsRequest() {
    try {
      await lastValueFrom(this.http.get(this.runSchemaMigration, { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getAuthorizationToken(), 'sessionID': this.getSessionID() }) }));
    } catch (e) {
      console.error("error running schema migration", e);
    }
  }

  setAuthorizationToken(authToken: string, initializeHttpOptions: boolean = true) {
    if (environment.useB2cAuthentication || environment.useKeycloakAuthentication) {
      sessionStorage.setItem(EndpointsService.AUTH_TOKEN, authToken);
      if (initializeHttpOptions) {
        this.initHttpOptions();
      }
      return;
    }

    this.cookieService.set(EndpointsService.AUTH_TOKEN, authToken, {
      path: '/',
      secure: true,
      sameSite: 'Strict'
    });
    if (initializeHttpOptions) {
      this.initHttpOptions();
    }
  }

  async setAuthSilentToken() {
    if (environment.useKeycloakAuthentication) {
      await this.keycloakService.updateToken().then((refreshed) => {
        /*if (refreshed) {
          console.log("Token was refreshed");
        } else {
          console.log("Token is still valid, no need to refresh");
        }*/
        this.setAuthorizationToken(this.keycloakService.getToken());
      }).catch((error) => {
        console.error("Failed to refresh token", error);
      });
    }
  }

  async sendInsertUserOnSchemaRequest() {
    try {
      // cant use httpOptions because it needs to run before initializing it
      await lastValueFrom(this.http.get(this.insertUserOnSchema,
        { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getAuthorizationToken(), 'sessionID': this.getSessionID() }) }));
    } catch (e) {
      console.error("error running schema migration", e);
    }
  }


  async createSessionId(authToken: string) {
    if (sessionStorage.getItem(EndpointsService.SESSION_ID) != null || this.isLocalHost()) {
      return;
    }

    const sessionId = await firstValueFrom(this.http.get(this.createSession, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + authToken }), // cant use this.httpOptions because it hasnt been initialized
      responseType: "text"
    }))

    sessionStorage.setItem(EndpointsService.SESSION_ID, sessionId);
  }

  getRandomNavaidsUrl(): string {
    const ports = [80, 81];
    const selectedPort = ports[Math.floor(Math.random() * ports.length)];
    console.log(`Selected port: ${selectedPort}`);
    return `http://localhost:${selectedPort}/navaids`;
  }
}
